import * as actions from './actionConstants';

export const getSeasonUmpireData = (seasonId) => ({
  type: actions.GET_SEASON_UMPIRE_DATA,
  seasonId
});

export const getSeasonUmpireDataSuccess = (umpires, umpiresList) => ({
  type: actions.GET_SEASON_UMPIRE_DATA_SUCCESS,
  umpires,
  umpiresList
});

export const getSeasonUmpireDataError = error => ({
  type: actions.GET_SEASON_UMPIRE_DATA_ERROR,
  error
});

export const getYtdSummaryData = () => ({
  type: actions.GET_YTD_DATA,
});

export const getYtdSummaryDataSuccess = (seasons, seasonsList) => ({
  type: actions.GET_YTD_DATA_SUCCESS,
  seasons,
  seasonsList
});

export const getYtdSummaryDataError = error => ({
  type: actions.GET_YTD_DATA_ERROR,
  error
});

export const getWheelData = (seasonId) => ({
  type: actions.GET_WHEEL_DATA,
  seasonId
});

export const getWheelDataSuccess = (wheelUmpires, wheelUmpiresList) => ({
  type: actions.GET_WHEEL_DATA_SUCCESS,
  wheelUmpires,
  wheelUmpiresList
});

export const getWheelDataError = error => ({
  type: actions.GET_WHEEL_DATA_ERROR,
  error
});

export const getFullSeasonStats = (parentSeasonId) => ({
  type: actions.GET_FULL_SEASON_STATS,
  parentSeasonId
});

export const getFullSeasonStatsSuccess = (seasons, seasonsList, umpires, umpiresList) => ({
  type: actions.GET_FULL_SEASON_STATS_SUCCESS,
  seasons,
  seasonsList,
  umpires,
  umpiresList
});

export const getFullSeasonStatsError = error => ({
  type: actions.GET_FULL_SEASON_STATS_ERROR,
  error
});

export const getUmpireStats = (seasonId, memberId) => ({
  type: actions.GET_UMPIRE_STATS,
  seasonId, memberId
});

export const getUmpireStatsSuccess = (umpireStats) => ({
  type: actions.GET_UMPIRE_STATS_SUCCESS,
  umpireStats
});

export const getUmpireStatsError = error => ({
  type: actions.GET_UMPIRE_STATS_ERROR,
  error
});

export const getTeamVolunteerData = (seasonId) => ({
  type: actions.GET_TEAM_VOLUNTEER_DATA,
  seasonId
});

export const getTeamVolunteerDataSuccess = (teams, teamsList) => ({
  type: actions.GET_TEAM_VOLUNTEER_DATA_SUCCESS,
  teams,
  teamsList
});

export const getTeamVolunteerDataError = error => ({
  type: actions.GET_TEAM_VOLUNTEER_DATA_ERROR,
  error
});


// WEBPACK FOOTER //
// ./src/actions/reportsActions.js